// extracted by mini-css-extract-plugin
export default {"Content":"HaG2sfJff7TmAo4mqDtE"};